import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import logoImage from '../../../assets/images/logo.webp';
import { WEBSITE_URL } from '../../../config/appConfig';

Logo.propTypes = {
	disabledLink: PropTypes.bool,
	sx: PropTypes.object,
};

export default function Logo({
	sx,
	url = WEBSITE_URL,
	target = '',
	logoWhite = false,
}) {
	const logo = (
		<a
			href={url}
			target={target}>
			<Box sx={{ width: 80, height: 80, ...sx }}>
				<img
					style={{ filter: logoWhite ? 'brightness(0) invert(1)' : '' }}
					alt=""
					src={logoImage}></img>
			</Box>
		</a>
	);

	return <>{logo}</>;
}
